// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"bf743a35","225":"60cf434b","243":"6f49c840","327":"d890f91c","376":"0cf32005","377":"1998d0fb","516":"beda21ff","605":"d6b090ab","610":"d740e153","662":"2509a2a6","694":"08ed3f73","744":"780cb13b","814":"7403003a","837":"555e288b","883":"6befac63","922":"8f7ea812"}[chunkId] + ".js";
};